import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { summaryRows } from '../data/summary';
export function SummaryTable() {
  return <section className="border-y border-electric/30 bg-surface py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-191" data-mp="o606ydatvopg">
      <div className="mx-auto max-w-4xl px-4" data-id="element-192" data-mp="j7ovjy4vx654">
        <SectionHeading id="summary-title" data-id="element-193" data-mp="j8zzbxybydw8">Everything Included:</SectionHeading>

        <ul className="mt-10 grid overflow-hidden rounded-2xl border border-electric/40 bg-background shadow-glow sm:grid-cols-2" data-id="element-194" data-mp="1gtmcvs7j35fh">
          {summaryRows.map(feature => <li key={feature} className="flex items-start gap-3 border-b border-electric/15 p-4 sm:odd:border-r" data-id="element-195" data-mp="16whodlq7mxvi">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-electric" data-id="element-196" data-mp="12vxnc72ina43">
                <CheckIcon className="h-3.5 w-3.5 text-background" aria-hidden="true" data-id="element-197" data-mp="3rnru9ee0rkhb" />
              </span>
              <b className="text-sm text-foreground" data-id="element-198" data-mp="3njttz0cyk3mo">{feature}</b>
            </li>)}
        </ul>
      </div>
    </section>;
}